import React from "react"
import { HourPickerSeeker } from "@ui-seeker/core"

import { startHour } from "@signals"

export default function AppCommonFiltersStartHourPicker({ ...props }) {
	return <HourPickerSeeker
		hideMinutes={minutes => minutes % 30 !== 0}
		value={startHour.value}
		onChange={e => startHour.value = e}
		label="Pickup time"
		{...props}
	/>
}